import { Box, Flex, Icon, Text } from "@chakra-ui/react";
import { EmrShieldPersons } from "@medstonetech/slate-icons";
import * as React from "react";

type HHERAllyHeaderProps = {
  variant: "prompt" | "drawer" | "plain";
  rightContent?: React.ReactNode;
};

function HHERAllyTitleGroup() {
  return (
    <Flex alignItems="center" gap="8px">
      <Icon as={EmrShieldPersons} width="15px" height="18px" color="#000000" />
      <Text
        fontSize="15px"
        fontWeight={500}
        letterSpacing="0.18px"
        lineHeight="18px"
        color="#000000"
      >
        HHER Ally
      </Text>
    </Flex>
  );
}

function HHERAllyHeader({ variant, rightContent }: HHERAllyHeaderProps) {
  if (variant === "plain") {
    return (
      <Flex justifyContent="center" paddingTop="21px">
        <HHERAllyTitleGroup />
      </Flex>
    );
  }

  const isDrawer = variant === "drawer";

  return (
    <Flex
      height="60px"
      width="100%"
      alignItems="center"
      justifyContent="center"
      position="relative"
      backgroundColor={isDrawer ? "#F8F8F8" : "transparent"}
      borderBottom={isDrawer ? "1px solid #D1D1D6" : undefined}
      flexShrink={0}
    >
      <HHERAllyTitleGroup />
      {rightContent && (
        <Box position="absolute" right="20px">
          {rightContent}
        </Box>
      )}
    </Flex>
  );
}

export { HHERAllyHeader };
export type { HHERAllyHeaderProps };
